import { Row } from "antd";
import styled from "styled-components";
import colors from "constants/colors";

export const FooterWrapper = styled(Row)`
  background-color: ${colors.primary};
  z-index: 2;
  border-top: 4px solid ${colors.secondary};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
`;
export const AccentDivider = styled.div`
  align-self: center;
  width: 80%;
  height: 1px;
  margin-top: -2%;
  margin-bottom: 2%;
  background: linear-gradient(90deg, transparent, ${colors.gray} 50%, transparent);
`;
